import {
  container,
//cardTitle,
//whiteColor,
//grayColor,
  ts_main
} from "assets/jss/material-dashboard-pro-react.jsx";

const StoreLocatorStyle = theme => ({
  container: {
    ...container,
    backgroundColor: "#FFFFFF",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px",
      paddingBottom: "0px"
    }
  },
  labelHeader: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.7rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#FFDD00",
    textAlign        : "center",
  },
  logo: {
    margin           : "1rem 0",
    "& img"          : {
      width   : "25%",
      display : "block",
      margin  : "auto"
    },
    "& span"          : {
      width        : "100px",
      height       : "1px",
      borderBottom : "3px solid " + ts_main[3],
      display      : "block",
      margin       : "1rem auto"
    }
  },
  label1: {
    fontSize     : "1rem",
    fontFamily   : '"Helvetica"',
    fontWeight   : "100",
    color        : "#3030",
    textAlign    : "left",
    "vertical-align":"middle",
  },
  textField1: { marginTop:10, marginBottom:10, input:{ color : "303030" } },

  StoreLocator_lbl_info: {
    marginTop        : 10,
    marginBottom     : 30,
    fontSize         : "0.95rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  StoreLocator_lbl_info2: {
    marginTop        : 5,
    marginBottom     : 5,
    fontSize         : "0.85rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  StoreLocator_lbl_info3: {
    marginTop        : 20,
    marginBottom     : -8,
    fontSize         : "0.80rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "550",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },

  StoreLocator_lbl_or: {
    position : "absolute",
    bottom   : 0,
    left     : 0,
    margin   : "0 0 20px -10px",
    [theme.breakpoints.down("md")]: {
      display : "none",
    }
  },

  StoreLocator_lbl_or_grid:{
    marginTop        : 20,
    // padding : "8px",
    alignItems : "center",
    justifyContent : "center",
    [theme.breakpoints.up("md")]: {
      display : "none",
    }
  },

  yellowButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginRight      : 5,
    marginTop        : 30,
    marginBottom     : 20,
    color            : "#303030",
    backgroundColor  : "#FFDD00",
    width            : "100%",
    'border-radius'  : "25px",
    'border'         : '2px solid',
    'border-color'   : "#FFDD00",
    "&:hover"        : { background: "#FFDD00 !important", color:"#303030 !important"},
    "&:focus"        : { background: "#FFDD00 !important", color:"#303030 !important"},
  },
  whiteButton: {
    textTransform    : "none",
    marginTop        : 30,
    marginBottom     : 20,
    color            : "#303030",
    backgroundColor  : "#FFFFFF",
    width            : "100%",
    'border-radius'  : "25px",
    'border'         : '2px solid',
    'border-color'   : "#FFDD00",
    "&:hover"        : { background: "#FFFFFF !important", color:"#303030 !important"},
    "&:focus"        : { background: "#FFFFFF !important", color:"#303030 !important"},
  },

  optionButton_active: {
    fontSize         : "0.75rem",
    fontWeight       : "600",
    textTransform    : "none",
    margin           : 2,
    paddingLeft      : 5,
    paddingRight     : 5,
    paddingTop       : 10,
    paddingBottom    : 10,
    color            : "#34B5B3",
    backgroundColor  : "rgba(158,247,247, 0.20)",
  //width            : "100%",
    'border-radius'  : "5px",
    'border'         : '2px solid',
    "&:hover"        : { background: "rgba(158,247,247, 0.20) !important", color:"#34B5B3 !important"},
    "&:focus"        : { background: "rgba(158,247,247, 0.20) !important", color:"#34B5B3 !important"},
  },
  optionButton_inactive: {
    fontSize         : "0.75rem",
  //fontWeight       : "250",
    textTransform    : "none",
    margin           : 2,
    paddingLeft      : 5,
    paddingRight     : 5,
    paddingTop       : 10,
    paddingBottom    : 10,
    color            : "#8c8c8c",
    backgroundColor  : "#FFFFFF",
  //width            : "100%",
    'border-radius'  : "5px",
    'border'         : '2px solid',
    "&:hover"        : { background: "rgba(158,247,247, 0.20) !important", color:"#34B5B3 !important"},
    "&:focus"        : { background: "#FFFFFF !important", color:"#8c8c8c !important", "box-shadow":"0 2px 2px 0 rgba(0, 108, 108, 0.14), 0 3px 1px -2px rgba(0, 108, 108, 0.2), 0 1px 5px 0 rgba(0, 108, 108, 0.12)"},
  },

  popupOkButton: {
    textTransform   : "none",
    backgroundColor : "#FFDD00",
    'border-radius' : "10px"
  },
  //----------
  //PleaseWait
  //----------
  pleaseWait: {
    marginTop        : 50,
  //marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
  //---------------
  //PleaseWaitPopup
  //---------------
  pleaseWaitPopup: {
    marginTop        : 0,
    marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    overflow         : "hidden",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
  //-----
  //[FAB]
  //-----
  fab: {
    margin: 0,
    top: '20',
    right: 0,
    // bottom: 20,
    left: 'auto',
    position: 'fixed',
  },


  paper: {
    overflowY: 'unset',
  },
  customizedButton : {
    position        : 'absolute',
    left            : '95%',
    top             : '-5%',
    backgroundColor : 'lightgray',
    color           : 'gray',
  },
  customizedButton_mobile : {
    position        : 'absolute',
    left            : '90%',
    top             : '-5%',
    backgroundColor : 'lightgray',
    color           : 'gray',
  }
});

export default StoreLocatorStyle;
